import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/product-sunseeker")({
  component: () => <Outlet />,
});
